@if (!isCompanyLoading()) {
  @if (companyWithPendingChanges()) {
    <div class="company-profile-container">
      <div class="company-profile-wrapper d-flex gap-24">
        <div class="left d-flex flex-column gap-24">
          <app-company-profile-card
            [disableControls]="isControlsDisabled()"
            [companyProfile]="companyWithPendingChanges()"
            [countPendingForm]="pendingDocuments().length"
            [showXpm]="isXpmConnected()"
            (openCompanyChangeNameForm)="openCompanyChangeNameForm()"
            (onCompanyRefreshed)="updateCompanyData()"
            (onSelectTab)="setActiveTab($event)"
          />

          <app-entity-profile-tags
            [disableControls]="isControlsDisabled()"
            [entityProfile]="companyWithPendingChanges()"
          />

          @if (pendingDocuments().length || isPendingDocumentsLoading()) {
            <app-entity-pending-changes
              [isLoading]="isPendingDocumentsLoading()"
              [disableControls]="isControlsDisabled()"
              [isPendingChangesVisible]="isPendingChangesVisible()"
              [pendingDocuments]="pendingDocuments()"
              [isCurrentChangesHighlighted]="isCurrentChangesHighlighted()"
              (setIsPendingChangesVisible)="setIsPendingChangesVisible($event)"
              (updatePendingDocuments)="updateCompanyData()"
              (deletePendingDocuments)="deleteDocument($event)"
              (openEditForm)="openDraftForm($event)"
            />
          }
        </div>

        <div class="right d-flex flex-column flex-grow-1">
          <div id="details" class="card mb-4">

            @if (!isTabsHidden()) {
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between gap-24">
                  <div class="left">
                    <div class="tab-container">
                      @for (tab of tabs; track $index) {
                        <app-tab-button
                          [isActive]="activeTab() === tab.title"
                          [isDisabled]="isControlsDisabled()"
                          (tabClicked)="setActiveTab(tab)"
                        >
                          {{ tab.title }}
                        </app-tab-button>
                      }
                    </div>

                    <div class="vertical-divider"></div>

                    <div class="notes-alerts-buttons">
                      <app-tab-button
                        iconClass="ic-alert-triangle-20"
                        [isActive]="alertsVisible()"
                        [isDisabled]="!this.lodgedCompany().alerts.length || isControlsDisabled()"
                        (tabClicked)="alertsVisible.set(!!this.lodgedCompany().alerts.length)"
                      >
                        {{ alertsLabel() }}
                      </app-tab-button>

                      <app-tab-button
                        *appHasRole="['Admin', 'Manager', 'Preparer']"
                        iconClass="ic-notes-20"
                        [isActive]="notesVisible()"
                        [isDisabled]="isControlsDisabled()"
                        (tabClicked)="notesVisible.set(true)"
                      >
                        {{ notesLabel() }}
                      </app-tab-button>
                    </div>
                  </div>

                  @if (activeTab() === 'Details') {
                    <div
                      *appHasRole="['Admin', 'Manager', 'Preparer']"
                      ngbDropdown
                      class="dropdown"
                      [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
                    >
                      <button
                        ngbDropdownToggle
                        id="company-actions-dd"
                        class="btn btn-primary d-flex align-items-center gap-2"
                        [disabled]="isControlsDisabled()"
                      >
                        <span>Actions</span>
                        <i class="icon ic-select-20"></i>
                      </button>

                      <div
                        ngbDropdownMenu
                        aria-labelledby="company-actions-dd"
                        class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                      >
                        @for (section of companyDetailsActions; track $index) {
                          <div class="dropdown-item-section">
                            <div class="section-title">{{ section.title }}</div>
                            <div class="sub-menu">
                              @for (item of section.subMenuItems; track $index) {
                                <button
                                  *appHasRole="item.roles"
                                  ngbDropdownItem
                                  class="dropdown-item {{ item.classes }}"
                                  [disabled]="item.disabled ?? false"
                                  (click)="item.action()"
                                >
                                  <i
                                    class="icon"
                                    [class]="item.iconClass ?? 'ic-form-20'"
                                  ></i>

                                  <div class="document">
                                    <div class="title">{{ item.title }}</div>
                                    <div class="asic-form">{{ item.formName }}</div>
                                  </div>
                                </button>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  } @else if (activeTab() === 'Officeholders') {
                    <div
                      *appHasRole="['Admin', 'Manager', 'Preparer']"
                      class="d-flex gap-2"
                    >
                      <button
                        id="officeholders-actions-dd"
                        type="button"
                        class="btn btn-primary d-flex align-items-center gap-2"
                        [disabled]="isControlsDisabled()"
                        (click)="openCompanyChangeOfficerAppointForm(selectedOfficeholders)"
                      >
                        <i class="icon ic-add-20"></i>
                        <span>Appointment of Officeholder</span>
                      </button>

                      <div ngbDropdown class="dropdown">
                        <button
                          ngbDropdownToggle
                          id="company-actions-dd-2"
                          class="btn btn-primary d-flex align-items-center gap-2"
                          [disabled]="isControlsDisabled()"
                        >
                          <span>Actions</span>
                          <i class="icon ic-select-20"></i>
                        </button>

                        <div
                          ngbDropdownMenu
                          aria-labelledby="company-actions-dd-2"
                          class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                        >
                          @for (item of officeholdersMenu; track $index) {
                            <button ngbDropdownItem class="dropdown-item" [class]="item.itemClass"
                                    (click)="item.action(selectedOfficeholders)">
                              <i class="icon" [class]="item.iconClass ?? 'ic-form-20'"></i>

                              <div class="document">
                                <div class="title">{{ item.title }}</div>
                                <div class="asic-form">{{ item.formName }}</div>
                              </div>
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  } @else if (activeTab() === 'Shareholders') {
                    <div class="d-flex justify-content-end gap-2">
                      <a
                        type="button"
                        class="btn btn-primary"
                        [routerLink]="isControlsDisabled() ? null : ['/shares', this.companyWithPendingChanges().entityId]"
                      >
                        <span>Share Register</span>
                      </a>

                      <div
                        *appHasRole="['Admin', 'Manager', 'Preparer']"
                        ngbDropdown
                        class="dropdown"
                      >
                        <button
                          ngbDropdownToggle
                          id="company-actions-dd-4"
                          class="btn btn-primary d-flex align-items-center gap-2"
                          [disabled]="isControlsDisabled()"
                        >
                          <span>Actions</span>
                          <i class="icon ic-select-20"></i>
                        </button>

                        <div
                          ngbDropdownMenu
                          aria-labelledby="company-actions-dd-4"
                          class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                        >
                          @for (item of shareholdersMenu; track $index) {
                            <button ngbDropdownItem class="dropdown-item" (click)="item.action()">
                              <i class="icon" [class]="item.iconClass ?? 'ic-form-20'"></i>

                              <div class="document">
                                <div class="title">{{ item.title }}</div>
                                <div class="asic-form">{{ item.formName }}</div>
                              </div>
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  } @else if (activeTab() === 'Documents') {
                    <div class="d-flex justify-content-end gap-2">
                      @if (selectedDocuments.length) {
                        <button
                          *appHasRole="['Admin', 'Manager', 'Preparer']"
                          type="button"
                          class="btn btn-primary d-flex align-items-center gap-2"
                          [disabled]="isControlsDisabled()"
                          (click)="deleteSelectedDocuments()"
                        >
                          <i class="icon ic-trash-20"></i>
                          <span>Delete documents</span>
                        </button>
                      } @else {
                        <div
                          *appHasRole="['Admin', 'Manager', 'Preparer']"
                          ngbDropdown
                          class="dropdown"
                          [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
                        >
                          <button
                            ngbDropdownToggle
                            id="company-actions-dd-3"
                            class="btn btn-primary d-flex align-items-center gap-2"
                            [disabled]="isControlsDisabled()"
                          >
                            <span>Actions</span>
                            <i class="icon ic-select-20"></i>
                          </button>

                          <div
                            ngbDropdownMenu
                            aria-labelledby="company-actions-dd-3"
                            class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                          >
                            @for (item of documentsMenu; track $index) {
                              <button ngbDropdownItem class="dropdown-item" (click)="item.action()">
                                <i class="icon" [class]="item.iconClass ?? 'ic-form-20'"></i>

                                <div class="document">
                                  <div class="title">{{ item.title }}</div>
                                  <div class="asic-form">{{ item.formName }}</div>
                                </div>
                              </button>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }

            <div>
              @if (activeTab() === 'Details') {
                <app-company-details [companyDetailsViewModel]="companyDetailsViewModel()"/>
              } @else if (activeTab() === 'Officeholders') {
                <app-company-officeholders
                  [officeholdersViewModel]="officeholdersViewModel()"
                  [disableControls]="isControlsDisabled()"
                  (patchOfficeholderViewModel)="patchOfficeholderViewModel($event)"
                  (ceaseRegisteredAgent)="openCompanyChangeOfficerCeaseForm($event)"
                  (companyChangePartyName)="openCompanyChangePartyNameForm($event)"
                  (changeOfficerAddress)="openCompanyChangeAddressForm($event)"
                  (selectOfficeholders)="onSelectOfficeholdersChange($event)"
                  (exportOfficeholders)="exportOfficeholders($event)"
                />
              } @else if (activeTab() === 'Shareholders') {
                <app-entity-securityholders-view
                  [isLoading]="isShareholdersLoading()"
                  [shareholdersViewModel]="shareholdersViewModel()"
                  (refreshShareholders)="loadShareholders()"
                  (patchShareholdersViewModel)="patchShareholdersViewModel($event)"
                  (selectShareholders)="onSelectShareholdersChange($event)"
                  (changeShareholderAddress)="openCompanyChangeAddressForm($event)"
                  (changeShareholderPartyName)="openCompanyChangePartyNameForm($event)"
                  (exportSecurityholders)="exportShareholders($event)"
                />
              } @else if (activeTab() === 'Documents') {
                <app-documents-grid
                  storageKey="company-documents"
                  [entityId]="companyWithPendingChanges().entityId"
                />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

<app-notes
  [entityId]="companyWithPendingChanges().entityId"
  [opened]="notesVisible()"
  (close)="notesVisible.set(false)"
  (notesTotalChanged)="onNotesTotalChanged($event)"
/>

<app-alerts-list
  [alerts]="companyWithPendingChanges().alerts"
  [entityType]="EntityType.Company"
  [entity]="companyWithPendingChanges()"
  [opened]="alertsVisible()"
  (close)="alertsVisible.set(false)"
/>

<app-loader minHeight="full" [loading]="isCompanyLoading()"/>
